/* eslint-disable jsx-a11y/anchor-is-valid */
import MuiPhoneNumber from 'material-ui-phone-number'
import {FormikValues} from 'formik'

const AddPropertyStep5 = ({formik}: FormikValues) => {
  return (
    <div data-kt-stepper-element='content'>
      <div className='w-100'>
        {/*Begin::Form Group Are you an*/}
        <div className='fv-row mb-3'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Are you an</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter property category'
            ></i>
          </label>
          <div className='d-flex w-100'>
            {/*Begin:Option owner*/}
            <label className='w-50 d-flex me-5 flex-basis-50 align-items-center justify-content-between cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='symbol symbol-50px me-2'>
                  <span className='symbol-label bg-light-primary'>
                    <i className='bi bi-file-earmark-person fs-2x'></i>
                  </span>
                </span>

                <span className='d-flex flex-column'>
                  <span className='fw-bolder fs-6'>Owner</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  {...formik.getFieldProps('isAgent')}
                  name='isAgent'
                  type='radio'
                  value='false'
                  id='isAgent'
                />
              </span>
            </label>
            {/*End::Option owner*/}

            {/*Begin:Option Agent*/}
            <label className='w-50 d-flex flex-basis-50 align-items-center justify-content-between cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='symbol symbol-50px me-2'>
                  <span className='symbol-label bg-light-danger'>
                    <i className='bi bi-file-earmark-person-fill fs-2x'></i>
                  </span>
                </span>

                <span className='d-flex flex-column'>
                  <span className='fw-bolder fs-6'>Agent</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  {...formik.getFieldProps('isAgent')}
                  name='isAgent'
                  type='radio'
                  value='true'
                  id='isAgent'
                />
              </span>
            </label>
            {/*End::Option Agent*/}
          </div>
          <div className='h-20px'>
            {formik.touched.isAgent && formik.errors.isAgent && (
              <div className='fv-help-block color-red'>{formik.errors.isAgent}</div>
            )}
          </div>
        </div>
        {/*End::Form Group Are you an*/}
        {formik.values.isAgent === 'true' && (
          <div className='mb-1'>
            {/*Begin::Form Group Owner Name*/}
            <div className='fv-row mb-3 ml-8'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Owner Name</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Enter owner name'
                ></i>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='owner_name'
                placeholder='Enter owner name'
                {...formik.getFieldProps('owner_name')}
              />
              <div className='h-20px'>
                {formik.touched.owner_name && formik.errors.owner_name && (
                  <div className='fv-help-block color-red'>{formik.errors.owner_name}</div>
                )}
              </div>
            </div>
            {/*End::Form Group Owner Name*/}
            {/*Begin::Form Group Owner Email*/}
            <div className='fv-row mb-3 ml-8'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Owner Email</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Enter owner email'
                ></i>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='owner_email_id'
                placeholder='Enter owner email'
                {...formik.getFieldProps('owner_email_id')}
              />
              <div className='h-20px'>
                {formik.touched.owner_email_id && formik.errors.owner_email_id && (
                  <div className='fv-help-block color-red'>{formik.errors.owner_email_id}</div>
                )}
              </div>
            </div>
            {/*End::Form Group Owner Email*/}
            {/*Begin::Form Group Phone Number*/}
            <div className='fv-row mb-3'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Phone Number</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title="Enter owner's phone number"
                ></i>
              </label>
              <MuiPhoneNumber
                {...formik.getFieldProps('owner_contact_number')}
                className='w-100'
                defaultCountry={'in'}
                onChange={(value: string) => formik.setFieldValue('owner_contact_number', value)}
              />
              <div className='h-20px'>
                {formik.touched.owner_contact_number && formik.errors.owner_contact_number && (
                  <div className='fv-help-block color-red'>
                    {formik.errors.owner_contact_number}
                  </div>
                )}
              </div>
            </div>
            {/*End::Form Group Phone Number*/}
          </div>
        )}
      </div>
    </div>
  )
}

export default AddPropertyStep5
